/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import {
	resources as opsReportsResources,
	opsReportsPermissionResource,
} from '@atlassian/eoc-ops-reports-common/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmGlobalOpsReportsRedirectRoute } from '@jira/router-routes__products-jsm-global-ops-reports-routes/src/productsJsmGlobalOpsReportsRedirectRoute.tsx';
import { LazyGlobalOpsReports, OpsReportsRedirect } from './ui/eoc/ops-reports/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const productsJsmGlobalOpsReportsRedirectRouteEntry: Route = createEntry(
	productsJsmGlobalOpsReportsRedirectRoute,

	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: OpsReportsRedirect,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			...opsReportsResources(),
			opsReportsPermissionResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyGlobalOpsReports],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
